export function parseVersionInfo(versionInfo) {
  if (!versionInfo) return {};
  if (typeof versionInfo === 'object') return versionInfo;
  try {
    return JSON.parse(versionInfo);
  } catch (err) {
    return {};
  }
}

export function getMarketVersionInfo(record) {
  const info = parseVersionInfo(record?.version_info);
  return record?.version_type === 'market' && info.market && typeof info.market === 'object'
    ? info.market
    : null;
}

export function getFirmwareVersionEntries(versionInfo) {
  const info = parseVersionInfo(versionInfo);
  const entries = [];

  Object.entries(info).forEach(([key, value]) => {
    if (key === 'market' || value == null || typeof value === 'object') return;
    const text = String(value).trim();
    if (!text) return;
    if (key === 'uiVersion') {
      entries.push({ key, label: 'UI', value: text, color: 'blue' });
      return;
    }
    entries.push({ key, label: key, value: text, color: undefined });
  });

  return entries;
}
